module.exports = __webpack_public_path__ + "img/welfare.a571eaea.png";